/* Configurable Micasa module; safe to re-render in the Shopify editor. */
window.MicasaInit.register("store-locator",scope=>{
'use strict';
const tx=value=>window.MicasaText(value);


    const locatorRoot=document.querySelector('[id^="micasa-store-locator-"]');if(!locatorRoot)return;const sectionId=locatorRoot.id.replace('micasa-store-locator-','');

    const allStores = window.MicasaData.stores;
    const contextParams = new URLSearchParams(location.search);
    let asianScope = contextParams.get("scope") === "asian";
    const knownAsianStores = allStores.filter(s=>s.asian).map(s=>s.slug);
    let stores = allStores.filter(store => !asianScope || knownAsianStores.includes(store.slug));
    const slugToId = Object.fromEntries(allStores.map(store => [store.slug, store.id]));
    const requestedSlug = contextParams.get("store") || contextParams.get("negozio") || document.body.dataset.defaultStore || "";
    const requestedStoreId = slugToId[requestedSlug] || "";

    const sectionEl = document.getElementById("micasa-store-locator-" + sectionId);
    const mapEl = document.getElementById("micasa-store-map-" + sectionId);
    const listEl = document.getElementById("micasa-store-list-" + sectionId);
    const metaEl = document.getElementById("micasa-store-result-meta-" + sectionId);
    const panelTitleEl = document.getElementById("micasa-store-panel-title-" + sectionId);
    const searchInput = document.getElementById("micasa-store-search-" + sectionId);
    const searchBtn = document.getElementById("micasa-store-search-btn-" + sectionId);
    const locationBtn = document.getElementById("micasa-store-location-btn-" + sectionId);
    const resetBtn = document.getElementById("micasa-store-reset-btn-" + sectionId);
    const filtersWrap = document.getElementById("micasa-store-filters-" + sectionId);
    const popularWrap = document.getElementById("micasa-popular-cities-" + sectionId);

    if (!sectionEl) return;

    let map;
    let markers = [];
    let currentStores = stores.slice();
    let activeFilter = "All";
    let userLocation = null;
    let userMarker = null;

    const text = new Proxy({...window.MicasaData.locatorCopy},{get:(target,key)=>target[key]??''});
    const localLocationLabel=window.MicasaSectionConfig('mc-stores-02').copy?.['Trova negozi vicino a me'];if(localLocationLabel!==undefined&&localLocationLabel!=='Trova negozi vicino a me')text.locationButtonDefault=localLocationLabel;

    const filterLabels = [window.MicasaData.locatorFilters.all||'Tutti',...new Set(allStores.map(s=>s.area).filter(Boolean)),window.MicasaData.locatorFilters.soon||'Prossima Apertura'];

    function loadLeaflet(callback) {
      if (window.L) {
        callback();
        return;
      }

      const existingScript = document.querySelector('script[src*="leaflet.js"]');

      if (existingScript) {
        scope.on.bind(scope,existingScript)("load", callback);
        return;
      }

      const script = document.createElement("script");
      script.src = window.MicasaAsset("leaflet/leaflet.js");
      script.onload = callback;
      document.head.appendChild(script);
    }

    function init() {
      if (!scope.active || !mapEl || typeof L === "undefined") return;
      if (mapEl.dataset.loaded === "true") return;

      mapEl.dataset.loaded = "true";

      map = L.map(mapEl, {
        scrollWheelZoom: false
      }).setView([43.7, 10.6], 7);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: "&copy; OpenStreetMap"
      }).addTo(map);

      renderFilters();
      bindEvents();
      resetLocationButton();
      setPanelTitle("default");
      if (asianScope) {
        text.listTitle = window.MicasaData.locatorFilters.asianTitle??'';
        text.defaultMeta = window.MicasaData.locatorFilters.asianDescription??'';
        setPanelTitle("default");
      }
      renderStores(stores);
      if (requestedStoreId) {
        const selectedIndex = currentStores.findIndex(store => store.id === requestedStoreId);
        if (selectedIndex >= 0) {
          activateStore(selectedIndex, false);
          const selectedCard = listEl.querySelector('[data-index="' + selectedIndex + '"]');
          if (selectedCard) listEl.scrollTop = selectedCard.offsetTop - listEl.offsetTop;
        }
      }

      scope.timeout.bind(scope)(function() {
        map.invalidateSize();
      }, 300);
    }

    function bindEvents() {
      if (searchBtn) {
        scope.on.bind(scope,searchBtn)("click", searchAddressOrKeyword);
      }

      if (searchInput) {
        scope.on.bind(scope,searchInput)("keydown", function(e) {
          if (e.key === "Enter") {
            searchAddressOrKeyword();
          }
        });

        scope.on.bind(scope,searchInput)("input", function() {
          if (!this.value.trim()) {
            setPanelTitle(userLocation ? "nearby" : "default");
            applySearch();
          }
        });
      }

      if (locationBtn) {
        scope.on.bind(scope,locationBtn)("click", useCurrentLocation);
      }

      if (resetBtn) {
        scope.on.bind(scope,resetBtn)("click", resetAll);
      }

      if (popularWrap) {
        popularWrap.querySelectorAll(".micasa-store-locator__popular-btn").forEach(function(btn) {
          scope.on.bind(scope,btn)("click", function() {
            const city = this.getAttribute("data-city") || "";
            if (searchInput) searchInput.value = city;
            setPanelTitle("search");
            applySearch();
          });
        });
      }
    }

    function renderFilters() {
      if (!filtersWrap) return;
      const allLabel=window.MicasaData.locatorFilters.all??'Tutti',soonLabel=window.MicasaData.locatorFilters.soon??'Prossima Apertura';
      const areas=Array.from(new Set(stores.map(store=>store.area).filter(Boolean)));
      const filters=[{value:'All',label:allLabel},...areas.map(area=>({value:area,label:area})),{value:'soon',label:soonLabel}].filter(filter=>String(filter.label??'').trim());
      activeFilter='All';
      filtersWrap.innerHTML=filters.map(filter=>`<button class="micasa-store-locator__filter-btn ${filter.value===activeFilter?'active':''}" type="button" data-filter="${escapeHtml(filter.value)}">${escapeHtml(filter.label)}</button>`).join('');
      filtersWrap.querySelectorAll('.micasa-store-locator__filter-btn').forEach(btn=>scope.on(btn,'click',function(){activeFilter=this.getAttribute('data-filter')||'All';filtersWrap.querySelectorAll('.micasa-store-locator__filter-btn').forEach(item=>item.classList.toggle('active',item===this));setPanelTitle(userLocation?'nearby':'search');applySearch()}));
    }

    function renderStores(targetStores) {
      currentStores = targetStores.slice();
      renderMarkers(targetStores);
      updateMeta(targetStores.length);

      if (!listEl) return;

      if (!targetStores.length) {
        listEl.innerHTML = window.MicasaTextHTML(`
          <div class="micasa-store-locator__empty">
            <div class="micasa-store-locator__empty-title">${escapeHtml(text.emptyTitle)}</div>
            <div>${escapeHtml(text.emptyText)}</div>
            <button class="micasa-store-locator__empty-action" type="button" data-reset="true">
              ${escapeHtml(text.resetButton)}
            </button>
          </div>
        `,listEl);

        const emptyReset = listEl.querySelector('[data-reset="true"]');
        if (emptyReset) scope.on.bind(scope,emptyReset)("click", resetAll);
        return;
      }

      listEl.innerHTML = window.MicasaTextHTML(targetStores.map(function(store, index) {
        const distanceText = Number.isFinite(store.distance) ? formatDistance(store.distance) : text.distanceUnavailable;
        const statusLabel = getStoreStatusLabel(store);
        const statusClass = store.status === "soon" ? "soon" : "";
        const directionText = userLocation ? text.directionButton : text.viewMapsButton;
        const phoneHref = getPhoneHref(store.phone);

        return `
          <article class="micasa-store-locator__card" data-index="${index}" data-store="${escapeHtml(store.slug)}" tabindex="0" aria-label="${escapeHtml(store.name)} — mostra sulla mappa">
            <div class="micasa-store-locator__card-top">
              <div class="micasa-store-locator__store-name">${escapeHtml(store.name)}</div>
              <span class="micasa-store-locator__status ${statusClass}">${escapeHtml(statusLabel)}</span>
            </div>

            <div class="micasa-store-locator__tags">
              <span class="micasa-store-locator__tag">${escapeHtml(store.city)}</span>
              <span class="micasa-store-locator__tag micasa-store-locator__tag--area">${escapeHtml(store.area)}</span>
            </div>

            <div class="micasa-store-locator__address">
              ${escapeHtml(store.address)}
            </div>

            ${store.openingHours ? `
              <div class="micasa-store-locator__info-line">
                <strong>${escapeHtml(text.hoursLabel)}:</strong> ${escapeHtml(store.openingHours).replace(/\r?\n/g,"<br>")}
              </div>
            ` : ""}

            ${store.phone ? `
              <div class="micasa-store-locator__info-line">
                <strong>${escapeHtml(text.phoneLabel)}:</strong>
                ${phoneHref ? `<a href="${escapeHtml(phoneHref)}">${escapeHtml(store.phone)}</a>` : escapeHtml(store.phone)}
              </div>
            ` : ""}

            ${store.note ? `<div class="micasa-store-locator__note">${escapeHtml(store.note).replace(/\r?\n/g,"<br>")}</div>` : ""}

            <div class="micasa-store-locator__card-bottom">
              <div class="micasa-store-locator__distance-wrap">
                <span class="micasa-store-locator__distance-label">${escapeHtml(text.distanceLabel)}</span>
                <span class="micasa-store-locator__distance">${escapeHtml(distanceText)}</span>
              </div>

              <a
                class="micasa-store-locator__direction"
                href="${escapeHtml(getGoogleMapsLink(store, userLocation))}"
                aria-label="${escapeHtml(directionText + ' — ' + store.name)}"
                target="_blank"
                rel="noopener"
              >
                ${escapeHtml(directionText)}
              </a>
            </div>
          </article>
        `;
      }).join(""),listEl);

      listEl.querySelectorAll(".micasa-store-locator__card").forEach(function(card) {
        scope.on.bind(scope,card)("click", function(e) {
          if (e.target.closest("a")) return;
          const index = Number(this.getAttribute("data-index"));
          activateStore(index);
        });
        scope.on.bind(scope,card)("keydown", function(e) {
          if (e.target !== card || (e.key !== "Enter" && e.key !== " ")) return;
          e.preventDefault();
          activateStore(Number(card.getAttribute("data-index")));
        });
      });
    }

    function renderMarkers(targetStores) {
      clearMarkers();

      targetStores.forEach(function(store, index) {
        if(!Number.isFinite(store.lat)||!Number.isFinite(store.lng))return;
        const marker = L.marker([store.lat, store.lng], {
          icon: createIcon(store, false),
          title: getStoreMarkerLabel(store),
          alt: getStoreMarkerLabel(store),
          keyboard: true
        }).addTo(map);

        setMarkerAccessibility(marker, store);

        marker.bindPopup(`
          <div>
            <div class="micasa-store-locator__popup-title">${escapeHtml(store.name)}</div>
            <div class="micasa-store-locator__popup-text">
              ${escapeHtml(getStoreStatusLabel(store))}<br>
              ${escapeHtml(store.city)}, ${escapeHtml(store.area)}<br>
              ${escapeHtml(store.address)}
            </div>
            <a
              class="micasa-store-locator__popup-link"
              href="${escapeHtml(getGoogleMapsLink(store, userLocation))}"
              aria-label="${escapeHtml(text.googleMaps + ' — ' + store.name)}"
              target="_blank"
              rel="noopener"
            >
              ${escapeHtml(text.googleMaps)}
            </a>
          </div>
        `);

        marker.on("click", function() {
          activateStore(index);
        });

        markers[index]={marker:marker,store:store};
      });

      fitMapToCurrentResults(false);
    }

    function getStoreMarkerLabel(store) {
      return [store.name, store.city].filter(Boolean).join(" — ");
    }

    function setMarkerAccessibility(marker, store) {
      const markerEl = marker && marker.getElement ? marker.getElement() : null;
      if (!markerEl) return;
      markerEl.setAttribute("aria-label", getStoreMarkerLabel(store));
      markerEl.setAttribute("title", getStoreMarkerLabel(store));
    }

    function clearMarkers() {
      markers.forEach(function(item) {
        map.removeLayer(item.marker);
      });

      markers = [];
    }

    function createIcon(store, active) {
      const primaryColor = getCssVar("--micasa-map-pin") || "#b3261e";
      const openingColor = getCssVar("--micasa-opening-pin") || "#f2b233";
      const bg = store.status === "soon" ? openingColor : primaryColor;
      const size = active ? 40 : 34;

      return L.divIcon({
        className: "",
        html:
          '<div style="' +
          'width:' + size + 'px;' +
          'height:' + size + 'px;' +
          'border-radius:999px;' +
          'background:' + bg + ';' +
          'border:4px solid #fff;' +
          'box-shadow:0 12px 28px rgba(0,0,0,.26);' +
          'display:flex;align-items:center;justify-content:center;color:' + (store.status === 'soon' ? '#182a35' : '#fff') + ';font-size:15px;font-weight:950;' +
          '">' +
          "M" +
          '</div>',
        iconSize: [size, size],
        iconAnchor: [size / 2, size],
        popupAnchor: [0, -size]
      });
    }

    function activateStore(index, scrollCard = true) {
      const store = currentStores[index];
      if (!store || !markers[index]) return;

      if (listEl) {
        listEl.querySelectorAll(".micasa-store-locator__card").forEach(function(card) {
          card.classList.remove("active");
        });

        const activeCard = listEl.querySelector('.micasa-store-locator__card[data-index="' + index + '"]');

        if (activeCard) {
          activeCard.classList.add("active");
          if (scrollCard) activeCard.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }

      markers.forEach(function(item, i) {
        item.marker.setIcon(createIcon(item.store, i === index));
        setMarkerAccessibility(item.marker, item.store);
      });

      map.stop();
      map.setView([store.lat, store.lng], 14, { animate: false });
      markers[index].marker.openPopup();
    }

    // Keep source values and their language aliases in the same local index.
    function searchableStore(store) {
      const fields = [store.name, store.city, store.area, store.address, store.note,
        store.openingHours, store.phone, store.status, store.statusLabel,
        store.home_description, ...(Array.isArray(store.tags) ? store.tags : []),
        knownAsianStores.includes(store.slug) ? "Alimentari asiatici" : ""];
      return normalize(window.MicasaLanguage?.searchText?.(fields) || fields.filter(value=>value!=null).join(" "));
    }

    function applySearch() {
      const keyword = searchInput ? normalize(searchInput.value.trim()) : "";

      let filtered = stores.filter(function(store) {
        const storeText = searchableStore(store);

        const filterMatch = matchesFilter(store, activeFilter);
        const keywordMatch = !keyword || storeText.indexOf(keyword) !== -1;

        return filterMatch && keywordMatch;
      });

      if (userLocation) {
        filtered = sortByDistance(filtered, userLocation);
      }

      renderStores(filtered);
    }

    async function searchAddressOrKeyword() {
      const value = searchInput ? searchInput.value.trim() : "";

      if (!value) {
        setPanelTitle(userLocation ? "nearby" : "default");
        applySearch();
        return;
      }

      const normalizedValue = normalize(value);
      const hasDirectStoreMatch = stores.some(function(store) {
        const storeText = searchableStore(store);

        return storeText.indexOf(normalizedValue) !== -1;
      });

      if (hasDirectStoreMatch) {
        setPanelTitle("search");
        applySearch();
        return;
      }

      try {
        if (metaEl) metaEl.textContent = text.searchingAddress;

        const location = await geocodeAddress(value + tx(", Italy"));
        userLocation = location;

        setPanelTitle("nearby");
        setLocationButtonSuccess();
        renderUserMarker(location, text.searchedLocation);

        let filtered = stores.filter(function(store) {
          return matchesFilter(store, activeFilter);
        });

        filtered = sortByDistance(filtered, location);
        renderStores(filtered);
        fitMapToCurrentResults(true);
      } catch (error) {
        setPanelTitle("search");
        applySearch();

        if (metaEl) {
          metaEl.textContent = text.addressNotFound;
        }
      }
    }

    async function geocodeAddress(address) {
      const url = "https://nominatim.openstreetmap.org/search?format=json&limit=1&q=" + encodeURIComponent(address);
      const response = await fetch(url);
      if (!response.ok) throw new Error("Address lookup failed");
      const data = await response.json();

      if (!data || !data.length) {
        throw new Error("Address not found");
      }

      return {
        lat: Number(data[0].lat),
        lng: Number(data[0].lon)
      };
    }

    function useCurrentLocation() {
      if (!window.isSecureContext) {
        if (metaEl) metaEl.textContent = text.locationHttps;
        resetLocationButton();
        return;
      }

      if (!navigator.geolocation) {
        if (metaEl) metaEl.textContent = text.locationUnsupported;
        resetLocationButton();
        return;
      }

      if (metaEl) metaEl.textContent = text.detectingLocation;
      setLocationButtonLoading();

      navigator.geolocation.getCurrentPosition(
        function(position) {if(!scope.active)return;
          userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          setPanelTitle("nearby");
          setLocationButtonSuccess();
          renderUserMarker(userLocation, text.currentLocation);

          let filtered = stores.filter(function(store) {
            return matchesFilter(store, activeFilter);
          });

          filtered = sortByDistance(filtered, userLocation);
          renderStores(filtered);
          fitMapToCurrentResults(true);
        },
        function(error) {if(!scope.active)return;
          let message = text.locationDenied;

          if (error && error.code === 1) {
            message = text.locationDenied;
          } else if (error && error.code === 2) {
            message = tx("Impossibile rilevare la tua posizione. Digita invece la tua città o il tuo indirizzo.");
          } else if (error && error.code === 3) {
            message = tx("La richiesta di posizione è scaduta. Riprova o digita il tuo indirizzo.");
          }

          resetLocationButton();

          if (metaEl) {
            metaEl.textContent = message;
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 12000,
          maximumAge: 0
        }
      );
    }

    function renderUserMarker(location, label) {
      if (userMarker) {
        map.removeLayer(userMarker);
      }

      userMarker = L.circleMarker([location.lat, location.lng], {
        radius: 8,
        color: getCssVar("--micasa-primary-dark") || "#7f1d1d",
        fillColor: getCssVar("--micasa-primary-dark") || "#7f1d1d",
        fillOpacity: 1
      }).addTo(map).bindPopup(label);

      userMarker.openPopup();
    }

    function fitMapToCurrentResults(includeUser) {
      if (!map) return;

      const boundsItems = markers.filter(Boolean).map(function(item) {
        return item.marker;
      });

      if (includeUser && userMarker) {
        boundsItems.push(userMarker);
      }

      if (!boundsItems.length) return;

      const group = L.featureGroup(boundsItems);
      map.stop();
      map.fitBounds(group.getBounds().pad(0.16), { animate: false });
    }

    function resetAll() {
      asianScope = false;
      stores = allStores.slice();
      text.listTitle = window.MicasaData.locatorCopy.listTitle;
      text.defaultMeta = window.MicasaData.locatorCopy.defaultMeta;
      userLocation = null;

      if (userMarker) {
        map.removeLayer(userMarker);
        userMarker = null;
      }

      if (searchInput) {
        searchInput.value = "";
      }

      resetLocationButton();
      setPanelTitle("default");

      if (filtersWrap) {
        const allButton = Array.from(filtersWrap.querySelectorAll(".micasa-store-locator__filter-btn")).find(function(btn) {
          return isAllFilter(btn.getAttribute("data-filter") || "");
        });

        filtersWrap.querySelectorAll(".micasa-store-locator__filter-btn").forEach(function(btn) {
          btn.classList.remove("active");
        });

        if (allButton) {
          allButton.classList.add("active");
          activeFilter = allButton.getAttribute("data-filter") || "All";
        } else {
          activeFilter = "All";
        }
      }

      renderStores(stores);
    }

    function sortByDistance(targetStores, location) {
      return targetStores
        .map(function(store) {
          return Object.assign({}, store, {
            distance: Number.isFinite(store.lat)&&Number.isFinite(store.lng)?getDistanceKm(location.lat, location.lng, store.lat, store.lng):Infinity
          });
        })
        .sort(function(a, b) {
          return a.distance - b.distance;
        });
    }

    function getGoogleMapsLink(store, origin) {
      if (origin && Number.isFinite(origin.lat) && Number.isFinite(origin.lng) && Number.isFinite(store.lat) && Number.isFinite(store.lng)) {
        return "https://www.google.com/maps/dir/?api=1&origin=" + origin.lat + "," + origin.lng + "&destination=" + store.lat + "," + store.lng;
      }

      if (store.googleMapsUrl) {
        return store.googleMapsUrl;
      }

      return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(store.address);
    }

    function getStoreStatusLabel(store) {
      if (store.statusLabel) return store.statusLabel;
      return store.status === "soon" ? text.openingLabel : text.storeLabel;
    }

    function getPhoneHref(phone) {
      if (!phone) return "";
      const cleaned = String(phone).replace(/[^+0-9]/g, "");
      return cleaned ? "tel:" + cleaned : "";
    }

    function setPanelTitle(mode) {
      if (!panelTitleEl) return;

      if (mode === "nearby") {
        panelTitleEl.textContent = text.nearbyListTitle;
        return;
      }

      if (mode === "search") {
        panelTitleEl.textContent = text.searchResultsTitle;
        return;
      }

      panelTitleEl.textContent = text.listTitle;
    }

    function setLocationButtonLoading() {
      if (!locationBtn) return;
      locationBtn.textContent = text.detectingLocation;
      locationBtn.disabled = true;
      locationBtn.setAttribute("aria-busy", "true");
      locationBtn.classList.remove("is-detected");
    }

    function setLocationButtonSuccess() {
      if (!locationBtn) return;
      locationBtn.textContent = text.locationButtonSuccess;
      locationBtn.disabled = false;
      locationBtn.setAttribute("aria-busy", "false");
      locationBtn.classList.add("is-detected");
    }

    function resetLocationButton() {
      if (!locationBtn) return;
      locationBtn.textContent = text.locationButtonDefault;
      locationBtn.disabled = false;
      locationBtn.setAttribute("aria-busy", "false");
      locationBtn.classList.remove("is-detected");
    }

    function updateMeta(count) {
      if (!metaEl) return;

      if (userLocation) {
        metaEl.textContent = replaceCount(text.sortedMeta, count);
        return;
      }

      if (hasActiveSearch()) {
        metaEl.textContent = replaceCount(text.countMeta, count);
        return;
      }

      metaEl.textContent = text.defaultMeta;
    }

    function hasActiveSearch() {
      const keyword = searchInput ? searchInput.value.trim() : "";
      return !!keyword || !isAllFilter(activeFilter);
    }

    function replaceCount(template, count) {
      return String(template || "").replace("[count]", count);
    }

    function matchesFilter(store, filter) {
      if (!filter || isAllFilter(filter)) return true;

      if (isSoonFilter(filter)) {
        return store.status === "soon";
      }

      const target = normalize(filter);

      return [
        store.area,
        store.city,
        store.status,
        store.statusLabel
      ].some(function(value) {
        return normalize(value) === target;
      });
    }

    function isAllFilter(filter) {
      const value = normalize(filter);if(filter===window.MicasaData.locatorFilters.all)return true;
      return [
        "all",
        "all stores",
        "all locations",
        "all micasa stores",
        "tutti",
        "tutti i negozi",
        "tutte le sedi"
      ].indexOf(value) !== -1;
    }

    function isSoonFilter(filter) {
      const value = normalize(filter);if(filter===window.MicasaData.locatorFilters.soon)return true;
      return [
        "opening soon",
        "coming soon",
        "prossima apertura",
        "in arrivo",
        "soon"
      ].indexOf(value) !== -1;
    }

    function getDistanceKm(lat1, lng1, lat2, lng2) {
      const earthRadius = 6371;
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return earthRadius * c;
    }

    function formatDistance(distanceKm) {
      if (distanceKm < 1) {
        return Math.round(distanceKm * 1000) + " m";
      }

      if (distanceKm < 10) {
        return distanceKm.toFixed(1) + " km";
      }

      return Math.round(distanceKm) + " km";
    }

    function toRad(value) {
      return value * Math.PI / 180;
    }

    function getCssVar(name) {
      if (!sectionEl) return "";
      return getComputedStyle(sectionEl).getPropertyValue(name).trim();
    }

    function normalize(value) {
      if (value === null || value === undefined) return "";
      return String(value).trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    function escapeHtml(value) {
      if (value === null || value === undefined) return "";

      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    loadLeaflet(function() {
      init();
    });

    
scope.defer(()=>{if(map){map.remove();map=null}if(mapEl)delete mapEl.dataset.loaded});
});
